import React from 'react';
import styled from 'styled-components';
import { RiDoubleQuotesL, RiDoubleQuotesR } from 'react-icons/ri';
import { FaTwitter, FaFacebookSquare } from 'react-icons/fa';

export const SingleTestimonialContainer = styled.div`
  width: 100%;
  padding: ${({ isPricing }) => (isPricing ? '30px 20px 25px' : '25px 20px')};
  @media (min-width: 992px) {
    padding: ${({ isPricing }) => (isPricing ? '30px 0px 25px' : '25px 0px')};
  }
  @media (min-width: 1200px) {
    padding: ${({ cardLayout }) => cardLayout === 'triple-recurrent' && '30px 0px'};
  }
`;

export const SingleTestimonialWrapper = styled.div`
  width: 100%;
  margin: 0px auto;
  padding: 15px;
  border-radius: ${({ cardLayout }) => (cardLayout === 'triple-recurrent' ? 'var(--pricingCardRadius)' : '20px')};
  border: 2px solid var(--lightColor);
  display: flex;
  align-items: center;
  flex-direction: column;
  @media (min-width: 481px) {
    padding: 18px;
  }
  @media (min-width: 576px) {
    flex-direction: row;
  }
  @media (min-width: 481px) {
    padding: 15px 25px;
  }
  @media (min-width: 992px) {
    width: var(--layoutWidth);
    padding: 15px 35px;
  }
  @media (min-width: 1200px) {
    width: ${({ cardLayout }) => (cardLayout === 'triple-recurrent' ? '95%' : 'var(--layoutWidth)')};
    max-width: var(--layoutMaxWidth);
  }
`;

export const SingleTestimonialImg = styled.img`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  @media (min-width: 576px) {
    width: 85px;
    height: 85px;
  }
  @media (min-width: 992px) {
    width: 90px;
    height: 90px;
  }
`;

export const SingleTestimonialTextWrapper = styled.div`
  padding-top: 15px;
  @media (min-width: 576px) {
    padding-top: 0px;
    padding-left: 30px;
  }
`;

export const SingleTestimonialText = styled.div`
  color: var(--normalTxtColor);
  font-family: var(--headingFont);
  font-size: 14px;
  @media (min-width: 992px) {
    font-size: 15px;
  }
  @media (min-width: 1400px) {
    font-size: 16px;
  }
  @media (min-width: 2000px) {
    font-size: 18px;
  }
`;

export const SingleTestimonialQuotes = styled.span`
  font-size: 15px;
  font-weight: 500;
  font-family: var(--headingFont);
  color: var(--dark);
  position: relative;
  top: -0.2rem;
  line-height: normal;
  @media (min-width: 992px) {
    font-size: 16px;
  }
  @media (min-width: 1400px) {
    font-size: 18px;
  }
  @media (min-width: 2000px) {
    font-size: 20px;
  }
`;

export const SingleTestimonialUsernameWrapper = styled.div`
  display: flex;
  align-items: center;
  padding-top: 8px;
  font-size: 14px;
  @media (min-width: 992px) {
    font-size: 15px;
  }
  @media (min-width: 1400px) {
    font-size: 16px;
  }
  @media (min-width: 2000px) {
    font-size: 18px;
  }
`;

export const SingleTestimonialUsername = styled.p`
  display: inline-block;
  margin-right: 5px;
  color: var(--dark);
  font-size: inherit;
  font-family: var(--headingFont);
  font-weight: 500;
`;

export default function SingleTestimonial({ cloudFront, isDsa, isPricing, cardLayout }) {
  return (
    <SingleTestimonialContainer isPricing={isPricing}>
      {isPricing ? (
        <SingleTestimonialWrapper cardLayout={cardLayout}>
          <SingleTestimonialImg src={cloudFront + '/Assets/TestimonialPics/bharath.jpg'} alt="reviewer photo" />
          <SingleTestimonialTextWrapper>
            <SingleTestimonialText>
              <SingleTestimonialQuotes>
                <RiDoubleQuotesL />
              </SingleTestimonialQuotes>
              Complex concepts can be easily learned through visual learning methods. <span className="darkTxt headingFont weight-500">Anyone can confidently face interviews</span>{' '}
              after learning from Log2Base2.
              <SingleTestimonialQuotes>
                <RiDoubleQuotesR />
              </SingleTestimonialQuotes>
            </SingleTestimonialText>
            <SingleTestimonialUsernameWrapper>
              <SingleTestimonialUsername>- Bharath</SingleTestimonialUsername>
              <FaFacebookSquare style={{ color: '#4267B2' }} />
            </SingleTestimonialUsernameWrapper>
          </SingleTestimonialTextWrapper>
        </SingleTestimonialWrapper>
      ) : isDsa ? (
        <SingleTestimonialWrapper>
          <SingleTestimonialImg src={cloudFront + '/Assets/reviewsProfile/vdpnroopesh.webp'} alt="reviewer photo" />
          <SingleTestimonialTextWrapper>
            <SingleTestimonialText>
              <SingleTestimonialQuotes>
                <RiDoubleQuotesL />
              </SingleTestimonialQuotes>
              When I was searching for data structure and algorithms YouTube recommended Log2Base2 videos those were simple, short and very interesting I watched{' '}
              <span className="darkTxt headingFont weight-500">data structures course with in 3 days</span>. I recommended it to all my friends. Everybody were surprised with these
              animated lectures. I <span className="darkTxt headingFont weight-500">never learned such complex topics in a short time</span>.
              <SingleTestimonialQuotes>
                <RiDoubleQuotesR />
              </SingleTestimonialQuotes>
            </SingleTestimonialText>
            <SingleTestimonialUsernameWrapper>
              <SingleTestimonialUsername>- Roopesh</SingleTestimonialUsername>
              <FaFacebookSquare style={{ color: '#4267B2' }} />
            </SingleTestimonialUsernameWrapper>
          </SingleTestimonialTextWrapper>
        </SingleTestimonialWrapper>
      ) : (
        <SingleTestimonialWrapper>
          <SingleTestimonialImg src={cloudFront + '/Feedback+Photos/Twitter+DP/Shravan+Venkataraman.png'} alt="reviewer photo" />
          <SingleTestimonialTextWrapper>
            <SingleTestimonialText>
              <SingleTestimonialQuotes>
                <RiDoubleQuotesL />
              </SingleTestimonialQuotes>
              Log2Base2 is a brilliant platform to visually learn - <span className="darkTxt headingFont weight-500">programming - data structures - algorithms</span>. Amazing,
              simple to understand animations they have created make understanding complicated programming constructs way easier.
              <SingleTestimonialQuotes>
                <RiDoubleQuotesR />
              </SingleTestimonialQuotes>
            </SingleTestimonialText>
            <SingleTestimonialUsernameWrapper>
              <SingleTestimonialUsername>- Shravan Venkataraman</SingleTestimonialUsername>
              <FaTwitter style={{ color: '#1DA1F2' }} />
            </SingleTestimonialUsernameWrapper>
          </SingleTestimonialTextWrapper>
        </SingleTestimonialWrapper>
      )}
    </SingleTestimonialContainer>
  );
}
